import { Suspense, lazy, useEffect, useState } from 'react';
import { Hearts } from 'react-loader-spinner';
import {  Route, Routes} from 'react-router-dom';
import SellerReviews from './components/Buyer/SellerReviews';
import { useLogin } from './Context/LoginContext';
import { useSubscriptionStatus} from './Context/SubscriptionStatusContext';

const Item = lazy(() => import(/* webpackChunkName: 'Checkout' */ './components/Item/Item'));
const SubscriptionManagement = lazy(() => import(/* webpackChunkName: 'Subscribe' */ './components/Buyer/Subscription/SubscriptionManagement'));
//const BuyerProducts = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/BuyerProducts'));

const SaIndProducts = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/Direct/SaIndProducts'));
// const Notifications = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/Notifications/Notifications'));
const SellerProfile = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/SellerProfile'));
const SubscribeCompletePage = lazy(() => import(/* webpackChunkName: 'Subscribe' */ './components/Buyer/Subscription/unused/SubscribeCompletePage'));
const FeaturedProducts = lazy(() => import(/* webpackChunkName: 'Shop' */ './components/Buyer/FeaturedProducts'));
const LoadingIndicator = () => (
  <div className="overlay">
    <Hearts color="#F05F40" height={100} width={100} />
  </div>
);
const SubscriptionProtectedRoutes = () => {
  const { token, isSA, isAdmin, buyer } = useLogin();
  const { loading, fetchSubscriptionStatus, isSubscriptionCachedValid } = useSubscriptionStatus();
  const [isSubscriptionStatusFetched, setIsSubscriptionStatusFetched] = useState(false);

  useEffect(() => {
// do this here to avoid having to do it every time we look at a product and click.
    if (token && buyer) {
      fetchSubscriptionStatus().then(() => {
        setIsSubscriptionStatusFetched(true);
      });
    } else {
      setIsSubscriptionStatusFetched(true);
     // isSubscriptionValid
     // they are not logged in...
    }
  //  console.log('protected route')
  }, []);

  if (loading || !isSubscriptionStatusFetched) {
    return <LoadingIndicator />;
  }
  ///console.log(token, isSubscriptionCachedValid,  isSubscriptionValid(), isSA, isAdmin)
    //console.log('SAProtectedRoutes reredner', isSubscriptionCachedValid,);
  // if (!isSubscriptionCachedValid && !isSA && !isAdmin) {
    return (
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
         
          <Route path=":username" element={<SaIndProducts />} />
          <Route path="favorites" element={<FeaturedProducts />} />
          <Route path="product/:username/:_id" element={<Item isSAlisting={true} />} />
          <Route path="profile/:username" element={<SellerProfile />} />
          <Route path="profile/:username/review" element={<SellerReviews />} />
          {/* the two below are valid only if the user is logged in and has a valid subscription */}
            
          <Route path="/subscription-management" element={<SubscriptionManagement />} />
          {/* <Route path="subscribe/complete" element={<SubscribeCompletePage />} /> */}
          {/* <Route path="dashboard" element={<SubscriptionManagement />} /> */}
          {/* <Route path="notifications" element={<Notifications />} /> */}
        </Routes>
      </Suspense>
    );
  
};

export default SubscriptionProtectedRoutes;